// extracted by mini-css-extract-plugin
export var alignCenter = "_4h-d";
export var bannerShown = "_4h-6";
export var buttonContent = "_4h-0";
export var cardList = "_4h-1";
export var centerContent = "_4h-2";
export var chevron = "_4h-3";
export var closePanelButton = "_4h-k";
export var conversationContextContainer = "_4h-l";
export var conversationDetailContainer = "_4h-4";
export var detailWrapper = "_4h-7";
export var dropdownButton = "_4h-e";
export var dropdownTitle = "_4h-9";
export var fullHeight = "_4h-5";
export var hidden = "_4h-a";
export var icon = "_4h-b";
export var mergeSuggestionWrapper = "_4h-m";
export var panel = "_4h-i";
export var portalButtonsWrapper = "_4h-c";
export var right = "_4h-j";
export var tableSummaryContainer = "_4h-8";
export var tableSummaryHeader = "_4h-g";
export var threeDotsButton = "_4h-f";
export var wide = "_4h-h";